{"id":"MenuButton","prefabs":{"default":{"children":[{"component":"MenuButton","options":"options:*"}]}}}